ServicesCtrl.$inject = ['$rootScope', '$scope', '$state', '$stateParams', 'PortalApi', 'Locations', 'configs', 'Notification', '$translate', 'Authentication', 'staticCategories', 'Localization'];

function ServicesCtrl($rootScope, $scope, $state, $stateParams, PortalApi, Locations, configs, Notification, $translate, Authentication, staticCategories, Localization) {
    var categoryId = $stateParams.categoryId;
    var lastSearchQuery = '';
    var off = 12;

    $scope.configs = configs;
    $scope.category = $stateParams.categoryId;
    $scope.getServices = search;
    $scope.searchServices = search;
    $scope.subscribe = $stateParams.subscribe;
    $scope.auth = Authentication;
    $scope.serviceCategoryId = categoryId;
    $scope.services = [];
    $scope.statCategories = staticCategories.catsIds;
    $scope.inServices = true;
    $rootScope.servicePage = false;

    var bannerCategories = ['all', '33', 33, '34', 34, '37', 37, '42', 42, '48', 48, '67', 67, 'other'];
    $scope.showBanner = bannerCategories.indexOf(categoryId) !== -1;

    init();

    $scope.loadMore = function() {

        var data = {
            query: lastSearchQuery,
            category: !categoryId || categoryId === 'all' ? 0 : parseInt(categoryId),
            sortByPayments: categoryId !== 'favorites' ? true : false,
            offset: off,
            onlyFavorites: categoryId === 'favorites' ? true : false,
            hiddenCategory: categoryId === 'other' ? $scope.statCategories : null
        };

        data.location = Locations.location.id;
        $scope.preLoader = true;

        if ($stateParams.subscribe) {
            data.twoStep = true;
        }

        PortalApi.getServices(data)
            .then(function(response) {

                $scope.services = $.merge($scope.services,response);

                $scope.services_new = !(response.length < 12);
                off += 12;

                $scope.preLoader = false;
            });
    };

    function search(query) {
        var data = {
            query: query,
            category: !categoryId || categoryId === 'all' ? 0 : parseInt(categoryId),
            sortByPayments: categoryId !== 'favorites' ? true : false,
            onlyFavorites: categoryId === 'favorites' ? true : false,
            hiddenCategory: categoryId === 'other' ? $scope.statCategories : null
        };

        lastSearchQuery = query;
        data.location = Locations.location.id;
        off = 12;

        $scope.preLoader = true;

        if ($stateParams.subscribe) {
            data.twoStep = true;
        }


        PortalApi.getServices(data)
            .then(function(response) {
                $scope.services = [];/*to avoid dublicates after push*/

                response.map(function (result) {
                    $scope.services.push(result);
                });

                if(response.length < 12){
                    $scope.services_new = false;
                }else{
                    $scope.services_new = true;
                }

                if(!response.length && categoryId === 'favorites'){
                    $scope.noFavorites = true;
                }

                $scope.preLoader = false;
            })
    }

    $scope.toService = function(serviceId, furl) {
        var data = {
            serviceId: serviceId,
            fields: [],
            amount: 0,
            autoCheck: false,
            url: serviceId
        };

        if (serviceId =='nonContractExternal') {
            data.serviceId = configs.payments_config.service.nonContractExternal;
            data.url = data.serviceId;
        }

        if (furl) {
          data.url = furl;
        }

        $scope.preLoader = true;

        if ($stateParams.subscribe) {
            data.subscribe = true;
        }

        $state.go('pages.payment', data);
    };

    $scope.manageFavorite = function (isFavorite,serviceId) {

        var data = {serviceId:serviceId};
        /*add/delete*/
        if(isFavorite){
            PortalApi.delFavorServices(data)
                .then(function () {
                    $scope.services.map(function (service) {
                        if(service.id == serviceId){
                            service.favorite = false;
                        }
                    });
                    $scope.notifySuccessMssg(mssgDel);
                }, function(reason) {
                    $scope.notifyErrorMssg(mssgDel);
                });
        }else{
            PortalApi.addFavorServices(data)
                .then(function () {
                    $scope.services.map(function (service) {
                        if(service.id == serviceId){
                            service.favorite = true;
                        }
                    });
                    $scope.notifySuccessMssg(mssgAdd);
                }, function(reason) {
                    $scope.notifyErrorMssg(mssgAdd);
                });
        }

        /*notify*/
        $scope.notifySuccessMssg = function (item) {
            Localization.notifyTemplate('success', 'SERVICES.FAVORITES.SUCCESS_'+ item, 5, true);
        };
        $scope.notifyErrorMssg = function (item) {
            Localization.notifyTemplate('error', 'SERVICES.FAVORITES.ERROR_'+ item, 5, true);
        };
        /*notify item messages*/
        var mssgAdd = 'ADD',
            mssgDel = 'DEL';
    };

    function init() {
        search($scope.query);
    }

    var listenerChangeLang = $rootScope.$on('changeLang', init);
    var listenerChangeLocation = $rootScope.$on('changeLocation', init);

    $scope.$on('$destroy', function () {
        listenerChangeLang();
        listenerChangeLocation();
    });
};

module.exports = ServicesCtrl;



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/services/controllers/services.js
 ** module id = 292
 ** module chunks = 1
 **/